// extracted by mini-css-extract-plugin
export default {"fileUpload2":"FileUpload2_fileUpload2__2bgTw"};